import { PageHeader, Styles } from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function AdoptionsMenu({ title }) {
  usePageTitle({ title })
  const { pathname } = useLocation()

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatórios por adoções"
        subtitle="Selecione o relatório que deseja visualizar"
        icon="fas fa-heart"
      />
      <table className="table">
        <thead>
          <tr>
            <th>Relatório</th>
            <th width="1" className="text-right">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 far fa-fw fa-heart" />
              Lista de adoções
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/adoptions-list`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 fas fa-fw fa-dog" />
              Adoções mensais por feira, manuais e diretas
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/monthly-adoptions-by-fair-manual-and-direct`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 fas fa-fw fa-blind" />
              Adoções por faixa etária
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/adoptions-by-age-group`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 fas fa-fw fa-money-bill" />
              Adoções por renda familiar
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/adoptions-by-family-income`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 fas fa-fw fa-map-marker-alt" />
              Adoções por região
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/adoptions-by-region`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </Styles.Container>
  )
}

export default AdoptionsMenu
